module.exports = __webpack_public_path__ + "img/bdabbdad8982e31e92438f8cbe9c5447.png";